import { Box, CircularProgress, Divider, Icon, Typography } from '@mui/material'
import AdxToolTip from 'components/custom/AdxToolTip'
import React, { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  downloadMtdFile,
  recalculateSelectedEmployee,
  resetMtdCalculation,
} from 'services/api/modules/payroll/payroll-view'
import Bugsnag from '@bugsnag/js'
import IncomeTaxAdjustmentModal from '../pages/payroll-run/components/IncomeTaxAdjustmentModal'
import { downloadResponseFile } from 'services/helper/fileDownload'

const DetailCalculation = ({
  data,
  time_id,
  editPage = false,
  editMtd = false,
  onEditStatutory,
}) => {
  const fileName = `mtd_calculation_${data?.name}.pdf`
  const employee_id = data?.id
  const [isLoadingDownloadMtd, setIsLoadingDownloadMtd] = useState(false)
  const [isLoadingReset, setIsLoadingReset] = useState(false)
  const { refetch } = useQuery(
    ['getMtdFile', { time_id, employee_id }],
    () =>
      downloadMtdFile({
        time_id,
        employee_id,
      }),
    {
      enabled: false,
      onSuccess: (res) => {
        downloadResponseFile(res, {
          fileName,
          contentType: 'application/pdf',
          successMessage: 'MTD calculation downloaded.',
        })
        if (res.data) {
          setIsLoadingDownloadMtd(false)
        }
      },
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
          setIsLoadingDownloadMtd(false)
        } else {
          Bugsnag.notify(error.data)
          setIsLoadingDownloadMtd(false)
        }
      },
    }
  )
  const downloadMtd = () => {
    setIsLoadingDownloadMtd(true)
    refetch()
  }

  //RECALCULATE
  const { mutate: recalculatePayroll } = useMutation(recalculateSelectedEmployee, {
    onSuccess: () => {
      setIsLoadingReset(false)
      queryClient.invalidateQueries('retrieveEmployeeData')
    },
    onError: (error) => {
      if (error.status === 422) {
        console.log(error)
      } else {
        Bugsnag.notify(error.data)
      }
    },
  })
  const queryClient = useQueryClient()
  const { refetch: refetchResetMtd } = useQuery(
    ['resetMtdCalculation', { time_id, employee_id }],
    () => resetMtdCalculation(time_id, employee_id),
    {
      enabled: false,
      onSuccess: () => {
        recalculatePayroll({ time_id, employee_id, data: {} })
      },
      onError: (error) => {
        if (error.status === 422) {
          console.log(error)
          setIsLoadingReset(false)
        } else {
          Bugsnag.notify(error.data)
          setIsLoadingReset(false)
        }
      },
    }
  )

  if (!data) return null

  const shouldShowSkbbk = data?.skbbk?.employee !== undefined && data?.skbbk?.employee !== null

  const handleResetMtd = () => {
    setIsLoadingReset(true)
    refetchResetMtd()
  }
  const ItemList = ({ name, amount, status, itemStatus, empStatus, sx, ...rest }) => {
    return (
      <Box
        display="flex"
        justifyContent={name === 'Gross pay' ? 'flex-end' : 'space-between'}
        alignItems="center"
        sx={{
          my: name !== 'Gross pay' && 1,
          color: 'light-gray-text.main',
          ...sx,
        }}
        {...rest}
      >
        {name === 'Gross pay' ? (
          <Typography variant="body2">{name}</Typography>
        ) : (
          <Typography>{name}</Typography>
        )}
        {status === 'add' ? (
          <Typography
            variant={name === 'Gross pay' ? 'body1' : 'subtitle1'}
            color="alternate.main"
            sx={{ ml: 6 }}
          >{`+ RM ${amount}`}</Typography>
        ) : status === 'deduct' ? (
          <Typography
            variant={name === 'Gross pay' ? 'body1' : 'subtitle1'}
            color="error.main"
            sx={{
              ml: 6,
              color:
                itemStatus === 4
                  ? 'error.main'
                  : itemStatus === 5
                    ? 'error.main'
                    : 'dark-text.main',
            }}
          >{`- RM ${amount}`}</Typography>
        ) : (
          <Typography
            variant={name === 'Gross pay' ? 'body1' : 'subtitle1'}
            color={empStatus === 1 ? 'yellow-01.main' : 'dark-text.main'}
            sx={{ ml: 6 }}
          >{`RM ${amount}`}</Typography>
        )}
      </Box>
    )
  }
  return (
    <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'light-gray-text.main',
            textDecoration: 'underline',
          }}
        >
          Remuneration
        </Typography>
        {/* <ItemList name="Basic salary" amount={data?.salary?.basic} empStatus={data.status} /> */}
        <ItemList name="Basic salary" amount={data?.salary?.basic} empStatus={data?.status} />
        {data?.overtime?.overtime_items?.length !== 0 && (
          <ItemList name="Overtime" amount={data?.overtime?.total_value} status="add" />
        )}
        {data?.additional
          ?.filter((item) => {
            if (item.status === 0 || item.status === 1 || item.status === 2 || item.status === 3) {
              return item
            } else {
              return null
            }
          })
          ?.map((list, index) => (
            <ItemList name={list.title} amount={list.value} key={index} status="add" />
          ))}
        {data?.additional
          ?.filter((item) => {
            if (item.status === 4) {
              return item
            } else {
              return null
            }
          })
          ?.map((list, index) => (
            <ItemList
              name={list.title}
              itemStatus={list.status}
              amount={list.value}
              key={index}
              status="deduct"
            />
          ))}
        <Divider sx={{}} />
        <ItemList name="Gross pay" amount={data?.salary?.gross} />
        <Divider />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            variant="subtitle2"
            color="light-gray-text.main"
            sx={{ textDecoration: 'underline' }}
          >
            Statutory contribution
          </Typography>
          {editPage && onEditStatutory && (
            <AdxToolTip title="Edit statutory contribution">
              <Icon
                onClick={onEditStatutory}
                sx={{ color: 'alternate.main', cursor: 'pointer', fontSize: 20 }}
              >
                edit_outlined
              </Icon>
            </AdxToolTip>
          )}
        </Box>
        <ItemList
          name={`EPF (${data?.epf?.epf_rate})`}
          amount={data?.epf?.employee}
          status="deduct"
        />
        <ItemList name="SOCSO" amount={data?.socso?.employee} status="deduct" />
        <ItemList name="EIS" amount={data?.eis?.employee} status="deduct" />
        {shouldShowSkbbk && (
          <ItemList name="SKBBK" amount={data?.skbbk?.employee} status="deduct" />
        )}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            my: 1,
            color: 'light-gray-text.main',
          }}
        >
          <Box display="flex" alignItems="center">
            <Typography sx={{ mr: 2 }}>Income Tax</Typography>
            {!editPage && (
              <AdxToolTip title="Generate MTD calculation">
                {isLoadingDownloadMtd ? (
                  <CircularProgress color="alternate" size={20} />
                ) : (
                  <Icon
                    onClick={() => downloadMtd()}
                    sx={{ color: 'alternate.main', cursor: 'pointer' }}
                  >
                    visibility
                  </Icon>
                )}
              </AdxToolTip>
            )}
          </Box>
          {editMtd ? (
            <Box display="flex" alignItems="center">
              {data?.mtd?.mtd_status === 1 &&
                (isLoadingReset ? (
                  <CircularProgress color="error" size={20} />
                ) : (
                  <AdxToolTip title="Reset to computerized MTD calculation">
                    <Typography
                      onClick={() => handleResetMtd()}
                      sx={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        color: 'error.main',
                      }}
                    >
                      Reset
                    </Typography>
                  </AdxToolTip>
                ))}
              {isLoadingReset ? (
                <Typography
                  sx={{
                    color: 'alternate.main',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    mx: 3,
                  }}
                >
                  Edit
                </Typography>
              ) : (
                <IncomeTaxAdjustmentModal data={data} time_id={time_id}>
                  <AdxToolTip title="Manually edit MTD calculation">
                    <Typography
                      sx={{
                        color: 'alternate.main',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        mx: 3,
                      }}
                    >
                      Edit
                    </Typography>
                  </AdxToolTip>
                </IncomeTaxAdjustmentModal>
              )}

              <Typography
                sx={{ color: 'dark-text.main' }}
              >{`- RM ${data?.mtd?.nett_mtd}`}</Typography>
            </Box>
          ) : (
            <Typography
              sx={{ color: 'dark-text.main' }}
            >{`- RM ${data?.mtd?.nett_mtd}`}</Typography>
          )}
        </Box>
        {data?.additional
          ?.filter((item) => {
            if (item.status === 5) {
              return item
            } else {
              return null
            }
          })
          ?.map((list, index) => (
            <ItemList
              key={index}
              name={list.title}
              amount={list.value}
              itemStatus={list.status}
              status="deduct"
            />
          ))}
      </Box>
      {Number(String(data?.salary?.claim ?? '0').replace(/,/g, '')) > 0 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography
            variant="subtitle2"
            color="light-gray-text.main"
            sx={{ textDecoration: 'underline' }}
          >
            Claims (not taxed)
          </Typography>
          <ItemList name="Approved claims" amount={data?.salary?.claim} status="add" />
        </Box>
      )}
      {!editPage && data?.mtd?.mtd_remarks !== '' && (
        <Box
          sx={{
            borderRadius: 2,
            bgcolor: 'default-background.main',
            p: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{ textDecoration: 'underline', color: 'light-gray-text.main' }}
          >
            Income tax adjustment remarks:
          </Typography>
          <Typography variant="body2" sx={{ color: 'light-gray-text.main' }}>
            {data?.mtd?.mtd_remarks}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default DetailCalculation
